import { render, staticRenderFns } from "./OrderPopup.vue?vue&type=template&id=2ab1541d&scoped=true"
import script from "./OrderPopup.vue?vue&type=script&lang=js"
export * from "./OrderPopup.vue?vue&type=script&lang=js"
import style0 from "./OrderPopup.vue?vue&type=style&index=0&id=2ab1541d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab1541d",
  null
  
)

export default component.exports